import { groq } from 'next-sanity'
import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { createMediaProjection } from './createMediaProjection'
import { createRichTextProjection } from './createRichTextProjection'
import { createLinkProjection } from './createLinkProjection'
export const createEventProjection = (
  localeId: string,
  includeFullContent = false,
): string => {
  const MEDIA_PROJECTION = createMediaProjection(localeId)
  const RICH_TEXT_PROJECTION = createRichTextProjection(localeId)
  const LINK_ACTION_PROJECTION = createLinkProjection(localeId)

  const baseProjection = groq`
    _id,
    ${coalesceLocaleField('title', localeId)},
    startDate,
    endDate,
    rsvpEndDate,
    primaryCta{
      link${LINK_ACTION_PROJECTION},
      ${coalesceLocaleField('label', localeId)},
      ${coalesceLocaleField('moreInformation', localeId)}
    },
    ${coalesceLocaleField('locationShort', localeId)},
    media${MEDIA_PROJECTION},
    "handle": path.current,
    isVipEvent,
    handleOverrideLink${LINK_ACTION_PROJECTION}
  `

  if (!includeFullContent) {
    return baseProjection
  }

  return groq`
    ${baseProjection},
    locationLong[]${RICH_TEXT_PROJECTION},
    locationLink${LINK_ACTION_PROJECTION},
    descriptionSection[]{
      ${coalesceLocaleField('title', localeId)},
      content[]${RICH_TEXT_PROJECTION}
    },
    infoSection[]{
      ${coalesceLocaleField('title', localeId)},
      content[]${RICH_TEXT_PROJECTION}
    }
  `
}
